// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "autonomia-58fcb.firebaseapp.com",
  "projectId": "autonomia-58fcb",
  "storageBucket": "autonomia-58fcb.appspot.com",
  "messagingSenderId": "297415343302",
  "appId": "1:297415343302:web:b90c899a6a192521c22bc7",
  "measurementId": "G-ZYJ3EEFTNM",
  "apiKey": "AIzaSyC89YO1ynnMf0jj5XsGeBGj99V2aW7hnIo"
};
